__turbopack_context__.v({
  "UiPulsingDot": "icon-module__4T0UOW__UiPulsingDot",
  "UiPulsingDot__animate": "icon-module__4T0UOW__UiPulsingDot__animate",
  "UiSpinner": "icon-module__4T0UOW__UiSpinner",
  "ping": "icon-module__4T0UOW__ping",
  "spin": "icon-module__4T0UOW__spin",
});
